import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface ISearchIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const SearchIcon = ({ color, ...props }: ISearchIconProps) => {
  const fill = color ?? COLORS['base-100'];

  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Container">
        <path
          id="Icon crop"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8324 15.7328C13.7618 16.4903 12.4448 16.9448 11.0343 16.9448C7.43149 16.9448 4.5 14.0326 4.5 10.4724C4.5 6.91215 7.43149 4 11.0343 4C14.6285 4 17.5685 6.91215 17.5685 10.4724C17.5685 11.9453 17.0672 13.3004 16.226 14.3945L20.2281 18.3672C20.415 18.5523 20.5 18.788 20.5 19.0405C20.5 19.5792 20.1006 20 19.5483 20C19.2934 20 19.047 19.9074 18.8601 19.7223L14.8324 15.7328ZM5.91052 10.4724C5.91052 13.2499 8.22172 15.5476 11.0343 15.5476C13.8383 15.5476 16.158 13.2499 16.158 10.4724C16.158 7.6949 13.8383 5.39716 11.0343 5.39716C8.22172 5.39716 5.91052 7.6949 5.91052 10.4724Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
